module.exports = __webpack_public_path__ + "static/media/rsz_1massan-131.d467bc86.jpg";